module.exports = __webpack_public_path__ + "assets/img/1.216434a8.jpg";